import { get } from 'lodash';
import { retrieveObjectMapper } from '../..';

export const transformProgramData = (programs = {}) => {
  return {
    data: {
      findAllProgram: {
        data: get(programs, 'data.data', []).map(item => {
          return retrieveObjectMapper(item, [
            'ID:id',
            'label',
            'type:type_string',
          ]);
        }),
        totalCount: get(programs, 'data.totalCount', 0),
      },
    },
    success: true,
  };
};

export default transformProgramData;
